// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2BpevHQVopCwe3WwXNIHLb","icon":"DtZKm7IORf4dHQ2IwqqEu","active":"kxBjVRSggRiRPrBcQJ1X9"};